import * as React from "react";
import { useState, useRef, useEffect } from "react";
import { default as firebase } from "common/Firebase";
import i18n from "i18n";
import classNames from "classnames";
import { LoginStore } from "modules/login/LoginStore";
import { ProfileStore } from "modules/profile/ProfileStore";
import {
  Card,
  CardContent,
  TextField,
  Grid,
  Button,
  withStyles,
  Typography,
  Checkbox,
  FormGroup,
  FormControlLabel,
  FormControl,
  InputLabel,
  Input,
  InputAdornment,
  IconButton,
  createMuiTheme,
  MuiThemeProvider,
  MenuItem,
  Select,
  Snackbar,
  CircularProgress,
  Link,
} from "@material-ui/core";
import {
  Visibility,
  VisibilityOff,
  Close as CloseIcon,
} from "@material-ui/icons";
import { unstable_useMediaQuery as useMediaQuery } from "@material-ui/core/useMediaQuery";
// import { exit } from "process";
import Utm from "modules/login/models/Utm";

const styles = (theme) => ({
  containerGrid: {
    padding: "3.75rem 2.5rem 0",
    "@media (max-width:959px)": {
      padding: "0",
    },
  },
  titleTrial: {
    color: "#9AAF00",
    fontFamily: "Raleway",
    fontStyle: "normal",
    fontWeight: 600,
    fontSize: "1.875rem",
    lineHeight: "2.188rem",
    textTransform: "uppercase" as any,
  },
  textTrial: {
    color: "#757575",
    fontFamily: "Roboto",
    fontStyle: "normal",
    fontWeight: 400,
    fontSize: "1.25rem",
    lineHeight: "1.438rem",
  },
  titleForm: {
    color: "#9AAF00",
    fontFamily: "Roboto",
    fontStyle: "normal",
    fontWeight: 600,
    fontSize: "1.25rem",
    lineHeight: "1.438rem",
    textTransform: "uppercase" as any,
  },
  checked: {
    display: "flex",
    alignItems: "flex-start",
    "& > span:nth-child(1)": {
      padding: " 0 .75rem",
    },
  },
  checked2: {
    padding: "0",
    color: "#9AAF00!important",
  },
  btnTeste: {
    backgroundColor: "#9AAF00",
    color: "#FFFFFF",
  },
  CardContent: {
    padding: "2.5rem 2rem 2rem 2rem",
  },
  margin: {
    margin: ".625rem 0px .313rem 0",
    "& span": {
      fontSize: ".75rem",
    },
  },
  textField: {
    margin: ".313rem 0",
  },
  formControl: {
    width: "100%",
  },
  iFrame: {
    display: "flex",
    justifyContent: "center",
    marginTop: "1.563rem",
    "& iframe": {
      border: "none",
    },
    "@media (max-width:959px)": {
      display: "none",
    },
  },
  success: {
    "& > div": {
      backgroundColor: "#198754!important",
    },
  },
  error: {
    "& > div": {
      backgroundColor: "#dc3545!important",
    },
  },
  formLoading: {
    height: "100%",
    width: "100%",
    backgroundColor: "RGBA(255,255,255, .7)",
    top: "0px",
    left: "0px",
    position: "absolute" as any,
    justifyContent: "center",
    alignItems: "center",
    display: "flex",
  },
});

const theme = createMuiTheme({
  palette: {
    primary: {
      light: "#9AAF00",
      main: "#9AAF00",
      dark: "#9AAF00",
      contrastText: "#9AAF00",
    },
  },
  typography: { useNextVariants: true },
});

const Register = (props) => {
  const { classes } = props;
  const [txtName, setTxtName] = useState("");
  const [txtEmail, setTxtEmail] = useState("");
  const [txtPassword, setTxtPassword] = useState("");
  const [txtCompany, setTxtCompany] = useState("");
  const [txtJob, setTxtJob] = useState("");
  const [txtPhone, setTxtPhone] = useState("");
  const [checkPrivacity, setCheckPrivacity] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [openSnack, setOpenSnack] = useState(false);
  const [messageSnack, setMessageSnack] = useState("");
  const [snackSuccess, setSnackSuccess] = useState(true);
  const [loadingForm, setLoadingForm] = useState(false);
  const [formOk, setFormOk] = useState(false);
  const inputTxtName = useRef(Input as any);
  const inputTxtEmail = useRef(Input as any);
  const inputTxtPassword = useRef(Input as any);
  const inputTxtCompany = useRef(Input as any);
  const inputTxtJob = useRef(Input as any);
  const inputTxtPhone = useRef(Input as any);
  const inputTxtPrivacity = useRef(Input as any);

  const jobs = [
    { key: 0, value: "CEO/Proprietário" },
    { key: 1, value: "Diretor/Vice-Presidente" },
    { key: 2, value: "Coordenador" },
    { key: 3, value: "Gerente" },
    { key: 4, value: "Analista" },
    { key: 5, value: "Assistente" },
    { key: 6, value: "Estagiário/Estudante" },
    { key: 7, value: "Outro" },
  ];

  const getUtmFromUrl = (url) => {
    url = url.split("?")[1];
    let utm: Utm = {
      utm_campaign: "",
      utm_keyword: "",
      utm_medium: "",
      utm_source: "",
      gclid: "",
    };

    if (url) {
      const urlParams = new URLSearchParams(url);
      utm.utm_campaign =
        urlParams.get("utm_campaign") == null
          ? ""
          : urlParams.get("utm_campaign");
      utm.utm_keyword =
        urlParams.get("utm_keyword") == null
          ? ""
          : urlParams.get("utm_keyword");
      utm.utm_medium =
        urlParams.get("utm_medium") == null ? "" : urlParams.get("utm_medium");
      utm.utm_source =
        urlParams.get("utm_source") == null ? "" : urlParams.get("utm_source");
      utm.gclid = urlParams.get("gclid") == null ? "" : urlParams.get("gclid");
    }
    return utm;
  };

  const sendForm = async (e) => {
    e.preventDefault();
    let url = document.URL;
    let utm: any = getUtmFromUrl(url);

    const isEmail = (email) => {
      var re = /\S+@\S+\.\S+/;
      return re.test(email);
    };
    if (!txtName) {
      inputTxtName.current.focus();
      return false;
    }
    if (!txtEmail || !isEmail(txtEmail)) {
      inputTxtEmail.current.focus();
      return false;
    }
    if (!txtPassword || txtPassword.length < 6) {
      inputTxtPassword.current.focus();
      return false;
    }
    if (!txtCompany) {
      inputTxtCompany.current.focus();
      return false;
    }
    if (!txtJob) {
      inputTxtJob.current.focus();
      return false;
    }
    if (!txtPhone) {
      inputTxtPhone.current.focus();
      return false;
    }
    if (!checkPrivacity) {
      inputTxtPrivacity.current.focus();
      return false;
    }
    setLoadingForm(true);
    try {
      let data = {
        email: txtEmail,
        jobTitle: txtJob,
        displayName: txtName,
        password: txtPassword,
        companyName: txtCompany,
        agreeTerms: checkPrivacity,
        phoneNumber: "+55" + txtPhone,
        gclid: utm.gclid,
        utm_campaign: utm.utm_campaign,
        utm_keyword: utm.utm_keyword,
        utm_medium: utm.utm_medium,
        utm_source: utm.utm_source,
      };
      const createNewUserTrial = firebase
        .functions()
        .httpsCallable("createNewUserTrial", { timeout: 300000 });
      await createNewUserTrial(data).then((resp) => {
        showAlert(resp.data.message);
        setLoadingForm(false);
      });
    } catch (error) {
      console.error("error", error);
      setLoadingForm(false);
    }
    return true;
  };

  const showAlert = async (resp) => {
    setOpenSnack(!openSnack);
    let message = "";
    let cl;

    switch (resp) {
      case "auth/user-created":
        message = "Usuário cadastrado com sucesso!";
        cl = true;
        break;
      case "auth/email-already-exists":
        message = "E-mail já cadastrado!";
        cl = false;
        break;
      case "auth/user-already-exists":
        message = "Usuário já cadastrado!";
        cl = false;
        break;
      case "auth/phone-number-already-exists":
        message = "Usuário já cadastrado!";
        cl = false;
        break;
      default:
        message = "Usuário já cadastrado!";
        cl = false;
        break;
    }
    setMessageSnack(message);
    setSnackSuccess(cl);
    if (cl) {
      try {
        const user = await firebase
          .auth()
          .signInWithEmailAndPassword(txtEmail, txtPassword);

        if (user) {
          await LoginStore.loadCurrentUser();
          const user_ = firebase.auth().currentUser as any;
          sendEmail();
        }
      } catch (error) {
        console.error(error);
      }
    }
    if (cl) setFormOk(true);
  };
  const sendEmail = () => {
    const user_ = firebase.auth().currentUser as any;
    user_.sendEmailVerification().catch((error) => console.error(error));
  };

  const privacyMessage = i18n.trialRegister.privacyPolicyMessage.split("%s");

  return !formOk ? (
    <>
      <Grid container className={classes.containerGrid}>
        <Grid item sm={12} md={7} xl={8} style={{ padding: "15px" }}>
          <Card style={{ height: "100%" }}>
            <CardContent className={classes.CardContent}>
              <Typography
                variant="h4"
                gutterBottom
                className={classes.titleTrial}
              >
                {i18n.trialRegister.requestTrial}
              </Typography>
              <Typography variant="body2" className={classes.textTrial}>
                {i18n.trialRegister.meetRubk01}
                <br /> <br />
                {i18n.trialRegister.meetRubk02}
                <br /> <br />
                {i18n.trialRegister.meetRubk03}
                <br /> <br />
                {i18n.trialRegister.meetRubk04}
              </Typography>
              <Grid className={classes.iFrame}>
                <iframe
                  width="560"
                  height="315"
                  src="https://www.youtube.com/embed/fcCRO4jwoOk?controls=0"
                  title="YouTube video player"
                  // frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  // allowfullscreen
                ></iframe>
              </Grid>
            </CardContent>
          </Card>
        </Grid>
        <Grid item sm={12} md={5} xl={4} style={{ padding: "15px" }}>
          <Card style={{ height: "100%", position: "relative" }}>
            <MuiThemeProvider theme={theme}>
              <CardContent className={classes.CardContent}>
                <Typography
                  variant="body2"
                  gutterBottom
                  align="center"
                  className={classes.titleForm}
                >
                  {i18n.trialRegister.freeTrialDays}
                </Typography>
                <div>
                  <form action="">
                    <TextField
                      inputProps={{
                        name: "txtName",
                        id: "txtName",
                      }}
                      inputRef={inputTxtName}
                      label="Nome"
                      className={classes.textField}
                      value={txtName}
                      onChange={(e) => setTxtName(e.target.value)}
                      margin="normal"
                      type="text"
                      required={true}
                      fullWidth
                    />
                    <TextField
                      inputProps={{
                        name: "txtEmail",
                        id: "txtEmail",
                      }}
                      label="E-mail"
                      inputRef={inputTxtEmail}
                      className={classes.textField}
                      value={txtEmail}
                      onChange={(e) => setTxtEmail(e.target.value)}
                      margin="normal"
                      type="email"
                      required={true}
                      fullWidth
                    />
                    <FormControl
                      fullWidth
                      className={classNames(classes.textField)}
                    >
                      <InputLabel htmlFor="adornment-password">
                        Senha * (6 ou mais caracteres)
                      </InputLabel>
                      <Input
                        inputProps={{
                          minlength: 6,
                          name: "txtName",
                          id: "txtName",
                        }}
                        inputRef={inputTxtPassword}
                        id="adornment-password"
                        type={showPassword ? "text" : "password"}
                        value={txtPassword}
                        onChange={(e) => setTxtPassword(e.target.value)}
                        fullWidth
                        required
                        endAdornment={
                          <InputAdornment position="end">
                            <IconButton
                              aria-label="Toggle password visibility"
                              onClick={() => setShowPassword(!showPassword)}
                            >
                              {showPassword ? (
                                <Visibility />
                              ) : (
                                <VisibilityOff />
                              )}
                            </IconButton>
                          </InputAdornment>
                        }
                      />
                    </FormControl>
                    <TextField
                      inputProps={{
                        name: "txtCompany",
                        id: "txtCompany",
                      }}
                      inputRef={inputTxtCompany}
                      label="Empresa"
                      className={classes.textField}
                      value={txtCompany}
                      onChange={(e) => setTxtCompany(e.target.value)}
                      margin="normal"
                      type="text"
                      required={true}
                      fullWidth
                    />
                    <FormControl className={classes.formControl}>
                      <InputLabel htmlFor="selectJob">Cargo</InputLabel>
                      <Select
                        fullWidth
                        value={txtJob}
                        onChange={(e) => setTxtJob(e.target.value)}
                        className={classes.textField}
                        inputProps={{
                          name: "selectJob",
                          id: "selectJob",
                        }}
                        inputRef={inputTxtJob}
                        required
                      >
                        {jobs.map((job) => {
                          return (
                            <MenuItem value={job.value}>{job.value}</MenuItem>
                          );
                        })}
                      </Select>
                    </FormControl>
                    <TextField
                      inputRef={inputTxtPhone}
                      id="standard-name"
                      label="Número de Telefone"
                      className={classes.textField}
                      value={txtPhone}
                      onChange={(e) => setTxtPhone(e.target.value)}
                      margin="normal"
                      type="tel"
                      required={true}
                      fullWidth
                      inputProps={{
                        name: "txtPhone",
                        id: "txtPhone",
                      }}
                    />
                    <FormGroup className={classes.margin}>
                      <FormControlLabel
                        className={classes.checked}
                        control={
                          <Checkbox
                            inputRef={inputTxtPrivacity}
                            required
                            checked={checkPrivacity}
                            onChange={(e) =>
                              setCheckPrivacity(e.target.checked)
                            }
                            value="privacity"
                            classes={{
                              root: classes.checked2,
                              checked: classes.checked2,
                            }}
                          />
                        }
                        labelPlacement="end"
                        label={
                          <>
                            {privacyMessage[0]}
                            <Link
                              href={ProfileStore.privacyPolicyLink}
                              target="_blank"
                            >
                              {i18n.trialRegister.privacyPolicy}
                            </Link>
                            {privacyMessage[1]}
                          </>
                        }
                      />
                    </FormGroup>
                    <FormGroup className={classes.margin}>
                      <Grid container direction="row" justify="center">
                        <Button
                          className={classes.btnTeste}
                          style={{ border: "none" }}
                          onClick={sendForm}
                        >
                          {i18n.trialRegister.freeTrial}
                        </Button>
                      </Grid>
                    </FormGroup>
                    <div>
                      <input type="hidden" name="utm_source" value="" />
                      <input type="hidden" name="utm_medium" value="" />
                      <input type="hidden" name="utm_campaign" value="" />
                      <input type="hidden" name="utm_value" value="" />
                      <input type="hidden" name="utm_keyword" value="" />
                    </div>
                  </form>
                </div>
              </CardContent>
              {loadingForm ? (
                <div className={classes.formLoading}>
                  <CircularProgress color="primary" disableShrink />
                </div>
              ) : (
                ""
              )}
            </MuiThemeProvider>
          </Card>
        </Grid>
      </Grid>
      <Snackbar
        key={1}
        className={snackSuccess ? classes.success : classes.error}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        open={openSnack}
        autoHideDuration={6000}
        onClose={() => setOpenSnack(!openSnack)}
        message={<span id="message-id">{messageSnack}</span>}
        action={[
          <IconButton
            key="close"
            aria-label="Close"
            color="inherit"
            onClick={() => setOpenSnack(!openSnack)}
          >
            <CloseIcon />
          </IconButton>,
        ]}
      />
    </>
  ) : (
    <Grid container justify="center">
      <Grid item xs={6} style={{ padding: "1.875rem 15px" }}>
        <Typography
          variant="body2"
          gutterBottom
          align="center"
          className={classes.titleForm}
        >
          {i18n.trialRegister.checkYourEmail}
        </Typography>
        <Typography
          variant="body1"
          gutterBottom
          align="center"
          className={classes.textTrial}
          style={{ margin: "2.188rem 0px" }}
        >
          {i18n.trialRegister.almostThere01} <br />
          <br />
          <b>{txtEmail}</b> <br />
          <br />
          {i18n.trialRegister.almostThere02}
          <br />
          {i18n.trialRegister.almostThere03}
        </Typography>
        <Typography
          variant="body1"
          gutterBottom
          align="center"
          className={classes.textTrial}
          style={{ margin: "2.188rem 0px 15px" }}
        >
          {i18n.trialRegister.almostThere04}
        </Typography>
        <Grid container direction="row" justify="center">
          <Button
            className={classes.btnTeste}
            style={{ border: "none" }}
            onClick={() => sendEmail()}
          >
            {i18n.trialRegister.resendEmail}
          </Button>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default withStyles(styles)(Register);



// WEBPACK FOOTER //
// ./src/modules/login/components/layouts/Register.tsx